export default {
  companies: [],
  reviews: []
};
